import React, { ReactNode, useState } from 'react'
import styled, { css } from 'styled-components'

import Container from '@components/Container'
import Box from '@components/Box'
import { SButtonHeader } from '@components/Button/Button'
import { STypography } from '@components/Typography'
import Logo from '@icons/logo.inline.svg'
import User from '@icons/user.inline.svg'
import { md, xl } from '@styles/variables/breakpoints'
import { above, below } from '@styles/mixins/breakpoints'
import SearchIcon from '@icons/search.inline.svg'
import BurgerIcon from '@icons/burger.inline.svg'
import CloseHeaderIcon from '@icons/close-header.inline.svg'
import theme from '@styles/theme'
import WithMedia from '@components/Utils/withMedia'
import Contact from './Contact'
import Ecosystem from './Ecosystem/'
import AutocompleteSearch from './AutocompleteSearch'

type TLink = {
  name: string
  url: string
  active: boolean
}

type TLinks = TLink[]

const LINKS: TLinks = [
  { name: 'Долгосрочные сбережения', url: 'https://pds.npfsb.ru/?utm_source=sbernpfsite&utm_medium=kppmbpage&utm_campaign=getpdscontract', active: false },
  { name: 'Перевести накопления в НПФ', url: '/ops/', active: false },
  { name: 'Малому бизнесу и ИП', url: '/lp/kpp/smallbusiness', active: true },
  { name: 'Корпоративным клиентам', url: '/business/', active: false },
  { name: 'О Фонде', url: '/about/', active: false },
  { name: ' Контакты', url: '/contacts/', active: false },
]

const SHeader = styled.header`
  height: 102px;
  z-index: 100;
  position: fixed;
  width: 100%;
  background: white;
  border-bottom: 1px solid #eaeaea;
  ${above('md')(css`
    height: 63px;
  `)}
  ${above('xl')(css`
    z-index: 1;
  `)}
`
const SLine = styled.div`
  background: ${({ theme }) => theme.gradients.main};
  height: 3px;

  ${above('md')(css`
    height: 6px;
  `)}
`
const SEcosystem = styled(Ecosystem)`
  margin-right: 8px;
  ${above('md')(css`
    margin-right: 16px;
  `)}
`

const SLogo = styled(Logo)`
  margin-right: 20px;
`

const SLogoLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
`

const SContainer = styled(Container)`
  padding-top: 12px;
  padding-left: 20px;
  padding-right: 20px;

  ${above('xl')(css`
    height: calc(100% - 6px);
    padding-top: 0;
    padding-left: 10px;
    padding-right: 10px;
  `)}

  ${above('md')(css`
    height: calc(100% - 6px);
    padding-top: 0;
  `)}
`

const SMobileButton = styled(SButtonHeader)`
  justify-content: center;
  margin: 12px 20px 20px 20px;
`

const SLkButton = styled(User)`
  width: 20px;
  height: 20px;
`

const SOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background: #333f48;
  opacity: 0.4;
`

const SWrapper = styled(Box)`
  position: fixed;
  width: 100%;
  background: white;
  z-index: 100;
  .npf-header__placeholder,
  .npf-header__content {
    height: 102px;
    ${above('md')(css`
      height: 63px;
    `)}
    ${above('xl')(css`
      height: 112px;
    `)}
  }
  .npf-header__content {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    border-bottom: 1px solid #eaeaea;
    background-color: #fff;
  }
  .npf-header__line {
    height: 6px;
    background: linear-gradient(90deg, #00d900 53.92%, #ffff00 100%);
  }
  .npf-header__search {
    flex-grow: 0;
    flex-shrink: 0;
  }
  .npf-header__links {
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    flex-direction: column;
    ${above('xl')(css`
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    `)}
  }
  .npf-header__link {
    padding: 14px 0;
    color: ${({ theme }) => theme.colors.black};
    border-bottom: 1px solid #eaeaea;
    text-align: right;
    transition: 0.2s;
    ${above('xl')(css`
      flex-grow: 0;
      flex-shrink: 0;
      margin: 0 17px;
      margin-bottom: -1px;
      padding: 14px 0 13px;
      border-bottom: 2px solid transparent;
      text-align: left;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      &:hover,
      &.active {
        border-color: #21a038;
      }
    `)}
  }
  .npf-header__overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    display: none;
    background: #333f48;
    opacity: 0.4;
    ${above('xl')(css`
      z-index: 101;
    `)}
  }
  .npf-header__close {
    margin: 0 0 0 auto;
    padding: 20px 0 20px 40px;
    cursor: pointer;
    ${above('xl')(css`
      display: none;
    `)}
  }
  .npf-header__menu {
    position: fixed;
    top: 0;
    padding: 0;
    right: -300px;
    width: 300px;
    height: 100%;
    background: #fff;
    transition: 0.3s;
    z-index: 100;
    ${above('md')(css`
      right: -450px;
      width: 450px;
    `)}
    ${above('xl')(css`
      z-index: 1;
      position: static;
      display: block;
      width: auto;
      height: auto;
      background: none;
    `)}
  }
  .npf-header__menu-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    ${above('xl')(css`
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    `)}
    .npf-header__search {
      ${below('xl')(css`
        display: none;
      `)}
    }
  }
  .npf-header__search,
  .npf-header__burger {
    cursor: pointer;
    ${above('xl')(css`
      padding: 13px;
      padding-right: 0;
    `)}
  }
  .npf-header__info {
    display: flex;
    align-items: center;
  }
  .npf-header__ecosystem {
    display: block;
    margin-right: 7px;
    & > svg {
      cursor: pointer;
    }
    ${above('md')(css`
      margin-right: 16px;
    `)}
  }
  .npf-header__base {
    padding: 11px 0;
    ${above('xl')(css`
      border-bottom: 1px solid #eaeaea;
    `)}
  }
  .npf-header__base-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    ${above('md')(css`
      flex-wrap: nowrap;
    `)}
    & > .npf-header__button_primary {
      margin-top: 12px;
      width: 100%;
      ${above('md')(css`
        display: none;
      `)}
    }
    ${below('xl')(css`
      padding-right: 20px;
      padding-left: 20px;
    `)}
  }
  .npf-header__control {
    display: flex;
    align-items: center;
    .npf-header__button {
      ${below('md')(css`
        margin-left: 12px;
      `)}
      &_primary {
        ${below('md')(css`
          display: none;
        `)}
      }
    }
  }
  .npf-header__logo {
    ${above('xl')(css`
      margin-right: 20px;
    `)}
  }
  .npf-header__contact {
    display: none;
    ${above('xl')(css`
      display: block;
    `)}
  }
  .npf-header__button {
    ${above('md')(css`
      margin-left: 16px;
    `)}
    ${above('xl')(css`
      margin-left: 24px;
    `)}
    &_mobile {
      margin-left: 12px;
      ${above('md')(css`
        margin-left: 16px;
      `)}
      ${above('xl')(css`
        display: none;
      `)}
    }
  }
  .npf-ecosystem {
    position: absolute;
    top: 60px;
    display: none;
    padding: 20px;
    width: 304px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 3px 28px rgba(73, 78, 83, 0.15);
  }
  .npf-ecosystem__icons {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
  .npf-ecosystem__icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    width: 30%;
  }
  .npf-ecosystem__image {
    margin-bottom: 8px;
  }
  .npf-ecosystem__link {
    text-align: center;
  }
  .npf-header-search {
    position: fixed;
    top: 102px;
    z-index: 100;
    display: block;
    width: 100%;
    ${above('md')(css`
      top: 63px;
    `)}
    ${above('md')(css`
      top: 20%;
      left: 50%;
      max-width: 700px;
      width: 100%;
      transform: translateX(-50%);
    `)}
    .npf-tile {
      background-color: #fff;
      border-radius: 8px;
      ${below('md')(css`
        border-radius: 0;
      `)}
    }
    .npf-header-search__button {
      display: none;
      flex-grow: 0;
      flex-shrink: 0;
      ${above('xl')(css`
        display: flex;
      `)}
    }
  }
  .npf-header-search__container {
    padding-right: 20px;
    padding-left: 20px;
    ${above('xl')(css`
      padding-right: 16px;
      padding-left: 16px;
    `)}
  }
  .npf-header-search__field {
    padding: 16px 0;
    width: 100%;
    outline: none;
    border: none;
    &::-ms-clear {
      display: none;
    }
    ${above('xl')(css`
      padding: 18px 0;
    `)}

    ${below('md')(css`
      font-size: 16px !important;
    `)}
  }
  .npf-header-search__form {
    display: flex;
    align-items: center;
  }
  .npf-header-search__icon {
    display: none;
    flex-grow: 0;
    flex-shrink: 0;
    margin-right: 12px;
    ${above('md')(css`
      display: block;
    `)}
  }
  .npf-header-search__clear {
    display: block;
    margin: 0 8px;
    padding: 0 8px;
    cursor: pointer;
  }
  .npf-container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding-right: 10px;
    padding-left: 0;

    ${below('xl')(css`
      padding-right: 40px;
      padding-left: 40px;
    `)}

    ${below('md')(css`
      padding-right: 20px;
      padding-left: 20px;
    `)}
  }
  .npf-autocomplete__list {
    list-style-type: none;
    border-top: 1px solid #f0f3f6;
    padding: 0 0 20px;
    ${above('xl')(css`
      padding: 12px 16px 20px;
    `)}
  }
  .npf-autocomplete__item {
    &:hover {
      background: #f0f3f6;
      cursor: pointer;
    }
    height: 44px;
    font-size: 14px;
    line-height: 20px;
    & > a {
      display: block;
      height: 100%;
      width: 100%;
      padding: 12px 0;
      color: #2d3033;
      margin-left: 0;
      ${above('xl')(css`
        margin-left: 10px;
      `)}
    }
  }
  .npf-typo_size_default {
    font-size: 14px;
    line-height: 20px;
  }

  .npf-typo_size_large_xl {
    ${above('xl')(css`
      font-size: 16px;
      line-height: 24px;
    `)}
  }

  .npf-header-button-box {
    display: flex;
    align-items: flex-start;
    ${below('xl')(css`
      align-items: center;
    `)}
  }
`

const SMenu = styled(Box)`
  border-bottom: 1px solid #eaeaea;
  position: relative;
  background: white;
  &.active {
    .npf-header__menu {
      right: 0;
    }
  }
  ${above('md')(css`
    top: 63px;
  `)}
`

export interface IHeaderProps {
  contacts?: ReactNode
  contractHref: string
}

const Header: React.FC<IHeaderProps> = ({ contacts, contractHref }) => {
  const [isHeaderMobileShow, setIsHeaderMobileShow] = useState(false)
  const [isSearchbarShow, setIsSearchbarShow] = useState(false)

  const handleHeaderMobile = () => {
    setIsSearchbarShow(false)
    setIsHeaderMobileShow((val) => !val)
  }
  const handleSearchbar = () => {
    setIsSearchbarShow((val) => !val)
  }
  return (
    <SWrapper>
      {isHeaderMobileShow && <SOverlay onClick={handleHeaderMobile} />}
      {isSearchbarShow && <SOverlay onClick={handleSearchbar} />}
      {isSearchbarShow && <AutocompleteSearch />}
      <SHeader>
        <SLine />
        <SContainer display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" justifyContent="center">
            <SEcosystem />
            <SLogoLink href="/">
              <SLogo />
            </SLogoLink>
            <WithMedia minWidth={xl}>
              <Contact desc="горячая линия">{contacts}</Contact>
            </WithMedia>
          </Box>
          <div className="npf-header-button-box">
            <WithMedia maxWidth={md}>
              <a href="https://lkjur.npfsb.ru/auth" target="_blank" rel="noreferrer" style={{ margin: 0, padding: 0 }}>
                <SLkButton />
              </a>
            </WithMedia>
            <WithMedia minWidth={md}>
              <>
                <SButtonHeader
                  href="https://lkjur.npfsb.ru/auth"
                  target="_blank"
                  icon={<User />}
                  link
                  type="secondary"
                  mr="8px"
                >
                  Личный кабинет для компании
                </SButtonHeader>
                <SButtonHeader as="a" href={contractHref} target="_blank" type="primaryGreen">
                  Заключить договор
                </SButtonHeader>
              </>
            </WithMedia>
            <div className="npf-header__search npf-header__button npf-header__button_mobile" onClick={handleSearchbar}>
              <SearchIcon />
            </div>
            <div
              className="npf-header__burger npf-header__button npf-header__button_mobile"
              onClick={handleHeaderMobile}
            >
              <BurgerIcon />
            </div>
          </div>
        </SContainer>
        <WithMedia maxWidth={md}>
          <SMobileButton as="a" href={contractHref} target="_blank" type="primaryGreen">
            Заключить договор
          </SMobileButton>
        </WithMedia>
      </SHeader>
      <WithMedia maxWidth={xl}>
        <SMenu className={isHeaderMobileShow ? 'active' : ''}>
          <SContainer>
            <div className="npf-header__menu">
              <div className="npf-container npf-header__menu-container">
                <div className="npf-header__close" onClick={handleHeaderMobile}>
                  <CloseHeaderIcon />
                </div>
                <nav className="npf-header__links">
                  {LINKS.map((link) => (
                    <a key={link.name} className={`npf-header__link ${link.active ? 'active' : ''}`} href={link.url}>
                      <STypography fontSize="14px" lineHeight="20px" fontFamily={theme.typography.defaultFontFamily}>
                        {link.name}
                      </STypography>
                    </a>
                  ))}
                </nav>
                <div className="npf-header__search" onClick={handleSearchbar}>
                  <SearchIcon />
                </div>
              </div>
            </div>
          </SContainer>
        </SMenu>
      </WithMedia>
      <WithMedia minWidth={xl}>
        <SMenu className="active">
          <SContainer>
            <div className="npf-header__menu">
              <div className="npf-container npf-header__menu-container">
                <div className="npf-header__close" onClick={handleHeaderMobile}>
                  <CloseHeaderIcon />
                </div>
                <nav className="npf-header__links">
                  {LINKS.map((link) => (
                    <a key={link.name} className={`npf-header__link ${link.active ? 'active' : ''}`} href={link.url}>
                      <STypography fontSize="14px" lineHeight="20px" fontFamily={theme.typography.defaultFontFamily}>
                        {link.name}
                      </STypography>
                    </a>
                  ))}
                </nav>
                <div className="npf-header__search" onClick={handleSearchbar}>
                  <SearchIcon />
                </div>
              </div>
            </div>
          </SContainer>
        </SMenu>
      </WithMedia>
    </SWrapper>
  )
}

export default Header
